export enum InspectionStatus {
  CREATED = 'CREATED',
  CREATING = 'CREATING',
  PENDING = 'PENDING',
}
